export default __webpack_public_path__ + "static/media/the-kingdom-area.9fb44a84.png";